import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../content/CommonStyles.module.css";
import { DisplayErrors } from "../../../Utils/ErrorHandler";
import { useFormik } from "formik";
import { formatShortDate, regions } from "../../../Utils/Utils";
import useApi from "../../../Utils/BackendClient";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import DropdownInput from "../Inputs/DropdownInput";
import RadioButtonInput from "../Inputs/RadioButtonInput";
import TextInput from "../Inputs/TextInput";
import CalendarInput from "../Inputs/CalendarInput";
import CheckboxInput from "../Inputs/CheckboxInput";
import { TabMenu } from "primereact/tabmenu";
import { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";

const CounterAgentCreationSidebar = ({ visible, onHide, toast, ctx, isMobile, componentKey, onCreate, isClient=false, isPartner=false }) => {

    const { createCagent } = useApi();

    const [loading, setLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);

    const formik = useFormik({
        initialValues: {
            type: "INDIVIDUAL",
            division: null,
            phone: "",
            email: "",
            is_partner: isPartner,
            is_client: isClient,
            country: "Україна",
            region: null,
            city: "",
            street: "",
            building_number: "",
            apartment_number: "",
            notes: "",
            individual_cagent_data: {
                first_name: "",
                last_name: "",
                surname: "",
                date_of_birth: null
            },
            legal_cagent_data: {
                long_name: "",
                short_name: "",
                representative: "",
                edrpou: ""
            },
            cagent_financial_data: []
        },
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.type === "INDIVIDUAL") {
                if (values.individual_cagent_data.last_name === null || values.individual_cagent_data.last_name === "") {
                    errors.indLastName = "Прізвище контрагента не повинне бути пустим";
                }

                if (values.individual_cagent_data.first_name === null || values.individual_cagent_data.first_name === "") {
                    errors.indFirstName = "Імя контрагента не повинне бути пустим";
                }
            }
            else {
                if (values.legal_cagent_data.long_name === null || values.legal_cagent_data.long_name === "") {
                    errors.legalLongName = "Повна назва організації не повинна бути пустою";
                }
            }

            if (values.division === null) {
                errors.division = "Точка продажу не повина бути пустою"
            }

            if (values.country === null || values.country === undefined) {
                errors.country = "Виберіть будь ласка країну"
            }

            if (values.region === null || values.region === undefined) {
                errors.region = "Виберіть будь ласка область"
            }

            if (values.city === null || values.city === "") {
                errors.city = "Населений пункт не повинен бути пустим"
            }

            if (!values.is_partner && !values.is_client) {
                errors.is_partner = "Контрагент повинен бути клієнтом або постачальником";
                errors.is_client = "Контрагент повинен бути клієнтом або постачальником";
            }

            values.cagent_financial_data.forEach((item, index) => {
                if (!item.data_type) {
                    if (!errors.cagent_financial_data) {
                        errors.cagent_financial_data = [];
                    }
                    errors.cagent_financial_data[index] = { data_type: "Data type is required" };
                }
            });

            return errors;
        },
        onSubmit: async (values) => {

            setLoading(true);

            let payload = {
                ...values,
                country: "UKRAINE",
                ...(values.type === "INDIVIDUAL"
                    ? {
                        individual_cagent_data: {
                            ...values.individual_cagent_data,
                            date_of_birth: values.individual_cagent_data?.date_of_birth
                                ? formatShortDate(values.individual_cagent_data.date_of_birth)
                                : null,
                        },
                        legal_cagent_data: null
                    }
                    : { individual_cagent_data: null }),
            }

            const { type, individual_cagent_data, legal_cagent_data, ...rest } = payload;

            payload = {
                type,
                ...rest,
                ...(type === "INDIVIDUAL" ? { individual_cagent_data } : { legal_cagent_data })
            };

            const response = await createCagent(payload);

            if (response.status === 201) {
                toast.current.show({
                    severity: "success",
                    summary: "Успіх створення контрагента",
                    detail: "Контрагента успішно створено",
                    life: 3000
                })

                if(values.is_client)
                {
                    ctx.resetEnum("clients");
                }

                if(values.is_partner)
                {
                    ctx.resetEnum("partners");
                }

                onCreate(response.data.id);
                setLoading(false);
                onHide();
                formik.resetForm();
            }
            else {
                setLoading(false);
                DisplayErrors(response.error, toast);
            }
        }
    });

    const mainToolbarLeftTemplate = () => {
        return <h3>Створення контрагента</h3>
    }

    const mainToolbarRightTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Зберегти" severity="success" loading={loading} className={commonStyle.addButton} type="submit" />
            </div>
        );
    }

    const items = [
        {
            label: 'Адреса',
            icon: 'pi pi-home',
            command: () => {
                setTabShowed(0);
            },
        },
        {
            label: 'Фінансові дані',
            icon: 'pi pi-money-bill',
            command: () => {
                setTabShowed(1);
            },
        }
    ];

    const AddCardButtonHandler = () => {
        const data = [...formik.values.cagent_financial_data,
        {
            data_type: "CARD",
            iban_number: "",
            mfo: "",
            bank_name: "",
            card_number: "",
            description: "",
        }
        ];

        formik.setFieldValue('cagent_financial_data', data);
    }

    const AddIBANButtonHandler = () => {
        const data = [...formik.values.cagent_financial_data,
        {
            data_type: "IBAN",
            iban_number: "",
            mfo: "",
            bank_name: "",
            card_number: "",
            description: "",
        }
        ];

        formik.setFieldValue('cagent_financial_data', data);
    }

    return (<Sidebar key={componentKey} visible={visible} position="right" onHide={onHide} className={commonStyle.pageSideBar}>
        <form onSubmit={formik.handleSubmit}>
            <Toolbar className="mb-4" start={mainToolbarLeftTemplate} end={mainToolbarRightTemplate} />
            <div className="grid nested-grid">
                <div className={`${commonStyle.leftMenu} col-3`}>
                    <DropdownInput 
                        formik={formik} 
                        paramName="division"
                        onChange={(val) => formik.setFieldValue("division", val)} 
                        context={ctx.enums.divisions.data} 
                        label="Точка продажу"
                        isMobile={isMobile} 
                        mandatory />
                    <RadioButtonInput
                        value={formik.values.type}
                        onChange={(val) => formik.setFieldValue("type", val)}
                        options={[
                            { value: "INDIVIDUAL", label: "Фізична особа" },
                            { value: "LEGAL", label: "Юридична особа" },
                        ]}
                    />
                    {formik.values.type === "INDIVIDUAL" && (<>
                        <TextInput formik={formik} paramName={"individual_cagent_data.last_name"} label={"Прізвище контрагента"} mandatory/>
                        <TextInput formik={formik} paramName={"individual_cagent_data.first_name"} label={"Ім'я контрагента"} mandatory/>
                        <TextInput formik={formik} paramName={"individual_cagent_data.surname"} label={"По-батькові контрагента"} />
                        <CalendarInput formik={formik} paramName={"individual_cagent_data.date_of_birth"} label={"Дата народження"} />
                    </>)}
                    {formik.values.type === "LEGAL" && (<>
                        <TextInput formik={formik} paramName={"legal_cagent_data.long_name"} label={"Повна назва контрагента"} mandatory />
                        <TextInput formik={formik} paramName={"legal_cagent_data.short_name"} label={"Скорочена назва контрагента"} />
                        <TextInput formik={formik} paramName={"legal_cagent_data.representative"} label={"Представник"} />
                        <TextInput formik={formik} paramName={"legal_cagent_data.edrpou"} label={"ЄДРПОУ"} />
                    </>)}
                    <TextInput formik={formik} paramName={"email"} label={"Email"} />
                    <TextInput formik={formik} paramName={"phone"} label={"Телефон"} />
                    <CheckboxInput formik={formik} paramName={"is_partner"} label={"Постачальник"} mainStyle={"mb-1 mt-1"}/>
                    <CheckboxInput formik={formik} paramName={"is_client"} label={"Клієнт"} mainStyle={"mb-1 mt-1"}/>
                </div>
                <div className="col-9">
                    <TabMenu model={items} />
                    {tabShowed === 0 && (<div className="grid">
                        <div className="col-4">
                            <TextInput formik={formik} paramName={"country"} label={"Країна"} customStyle="w-11" mandatory/>
                            <TextInput formik={formik} paramName={"street"} label={"Вулиця"} customStyle="w-11" />
                        </div>
                        <div className="col-4">
                            <DropdownInput 
                                formik={formik}
                                paramName={"region"}
                                context={regions}
                                onChange={(val) => formik.setFieldValue("region",val)} 
                                label={"Область"}
                                customStyle="w-11"
                                mandatory />
                            <TextInput formik={formik} paramName={"building_number"} label={"Номер будинку"} customStyle="w-11" />
                        </div>
                        <div className="col-4">
                            <TextInput formik={formik} paramName={"city"} label={"Місто"} customStyle="w-11" mandatory />
                            <TextInput formik={formik} paramName={"apartment_number"} label={"Квартира"} customStyle="w-11" />
                        </div>
                        <div className={`p-inputgroup col-8`}>
                            <span className="p-float-label md:w-90">
                                <InputTextarea value={formik.values.description} onChange={(e) => { formik.setFieldValue('description', e.target.value) }} rows={10} cols={80} />
                                <label>Примітки</label>
                            </span>
                        </div>
                    </div>)}
                    {tabShowed === 1 && (<>
                        {(formik.values.cagent_financial_data.map((finData, index) => (
                            <div className="grid" key={index}>
                                <div className="col-4">
                                    {finData.data_type === "IBAN" &&
                                        <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                            <FloatLabel>
                                                <InputText value={finData.iban_number || ""}
                                                    onChange={(e) => formik.setFieldValue(`cagent_financial_data[${index}].iban_number`, e.target.value)} />
                                                <label>Номер IBAN</label>
                                            </FloatLabel>
                                        </div>}
                                    {finData.data_type === "CARD" && <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                        <FloatLabel>
                                            <InputText value={finData.card_number || ""}
                                                onChange={(e) => { formik.setFieldValue(`cagent_financial_data[${index}].card_number`, e.target.value) }} />
                                            <label>Номер картки</label>
                                        </FloatLabel>
                                    </div>}
                                </div>
                                <div className="col-4">
                                    {finData.data_type === "IBAN" && <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                        <FloatLabel>
                                            <InputText value={finData.bank_name || ""}
                                                onChange={(e) => { formik.setFieldValue(`cagent_financial_data[${index}].bank_name`, e.target.value) }} />
                                            <label>Назва банку</label>
                                        </FloatLabel>
                                    </div>}
                                </div>
                                <div className="col-3">
                                    {finData.data_type === "IBAN" && <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                        <FloatLabel>
                                            <InputText value={finData.mfo || ""}
                                                onChange={(e) => { formik.setFieldValue(`cagent_financial_data[${index}].mfo`, e.target.value) }} />
                                            <label>МФО</label>
                                        </FloatLabel>
                                    </div>}
                                </div>
                                <div className="col-1">
                                    <Button
                                        icon="pi pi-trash"
                                        className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                                        style={{ marginTop: "2rem" }}
                                        tooltip="Видалити"
                                        tooltipOptions={{ showOnDisabled: true }}
                                        type="button"
                                        onClick={() => {
                                            const newArray = formik.values.cagent_financial_data.filter((_, i) => i !== index);
                                            formik.setFieldValue('cagent_financial_data', newArray);
                                        }}
                                    />
                                </div>
                            </div>
                        )))}
                        <div className="col-12">
                            <Button icon="pi pi-credit-card" label="Додати картку" severity="success" className={`${commonStyle.addButton} ${commonStyle.addButtonNav}`} onClick={AddCardButtonHandler} type="button" />
                            <Button icon="pi pi-money-bill" label="Додати рахунок" severity="success" className={commonStyle.addButton} onClick={AddIBANButtonHandler} type="button" />
                        </div>
                        <div className={`${commonStyle.inputfields} p-inputgroup col-8`}>
                            <span className="p-float-label md:w-90">
                                <InputTextarea value={formik.values.cagent_financial_data.description} onChange={(e) => { formik.setFieldValue('cagent_financial_data.description', e.target.value) }} rows={10} cols={80} />
                                <label>Примітки</label>
                            </span>
                        </div>
                    </>)}
                </div>
            </div>
        </form>
    </Sidebar>);
}

export default CounterAgentCreationSidebar;